<template>
  <a-card :bordered="false" :loading="loading.page" v-if="loading.page">
    Loading
  </a-card>
  <div v-else>
    <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading.page" class="margin-bottom">
            <div slot="title">
              <h4 class="margin-remove">Kewajiban Manifest</h4>
              <small>{{ data_header ? data_header.no_kewajiban : null }}</small>
            </div>

            <!-- header section -->
            <a-popover
              v-if="actor == 'Creator'"
              slot="extra"
              trigger="click"
              placement="bottom"
            >
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li v-if="getAuth.username == data_header.tlc_create">
                  <a-button-group style="display: flex;">
                    <a-button
                      :disabled="data_header.last_status !== 'Revised'"
                      style="width: 100%;"
                      type="dashed"
                      icon="edit"
                      @click="navigateTo('kewajiban_edit', data_header.kewajiban_id)"
                      >Edit</a-button
                    >
                    <!-- <a-button
                        type="danger"
                        icon="close-square"
                        >Cancel</a-button
                      > -->
                  </a-button-group>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <!-- content section -->
            <div class="m-card-body">
              <a-row>
                <a-col span="12">
                  <ul class="m-list-wrapper bordered">
                    <li>
                      <span class="m-list-title" for>Date / TLC</span>
                      <span class="m-list-desc">{{
                        moment(data_header.create_dt).format("YYYY-MM-DD") +
                          " / " +
                          data_header.tlc_create
                      }}</span>
                    </li>

                    <li>
                      <span class="m-list-title" for>Tanggal Kewajiban</span>
                      <span class="m-list-desc">{{
                        moment(data_header.tgl_kewajiban).format("YYYY-MM-DD")
                      }}</span>
                    </li>

                    <li>
                      <span class="m-list-title" for>Description</span>
                      <span class="m-list-desc">{{
                        data_header.description
                      }}</span>
                    </li>

                    <li>
                      <span class="m-list-title" for>Nilai</span>
                      <span class="m-list-desc">{{
                        customFormatCurrency(
                          data_header.currency,
                          data_header.nilai
                        )
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Nilai Kurs IDR</span>
                      <span class="m-list-desc">{{
                        customFormatCurrency("IDR", data_header.kurs_idr)
                      }}</span>
                    </li>
                    <li v-if="data_header.prospek_no">
                      <span class="m-list-title" for>Prospek</span>
                      <span class="m-list-desc">
                        <div><a @click="gotoManifest(data_header.prospect_id)">{{ data_header.prospek_no }}</a></div>
                        <div>{{ data_header.prospek_deskripsi }}</div>
                        <div><i><small>{{customFormatCurrency("IDR", data_header.prospek_biaya)}}</small></i></div>
                      </span>
                    </li>
                  </ul>
                </a-col>
                <a-col sapn="12">
                  <ul class="m-list-wrapper bordered">
                    <li>
                      <span class="m-list-title" for>Beneficiary</span>
                      <span class="m-list-desc">{{
                        data_header.beneficiary
                      }}</span>
                    </li>

                    <li>
                      <span class="m-list-title" for
                        >No. Invoice / SK / Referensi</span
                      >
                      <span class="m-list-desc">{{
                        data_header.no_invoice ? data_header.no_invoice : "-"
                      }}</span>
                    </li>

                    <li>
                      <span class="m-list-title" for>Cost Center</span>
                      <span class="m-list-desc">{{
                        data_header.cost_center_kode
                      }}</span>
                    </li>

                    <li>
                      <span class="m-list-title" for>Item Anggaran</span>
                      <span class="m-list-desc"
                        >{{ data_header.kode_anggaran }} -
                        {{ data_header.item_anggaran }}</span
                      >
                    </li>

                    <li v-if="data_header.user_cc && data_header.no_cc">
                      <span class="m-list-title" for>User CC / No CC</span>
                      <span class="m-list-desc"
                        >{{ data_header.user_cc }} /
                        {{ data_header.no_cc }}</span
                      >
                    </li>

                    <li>
                      <span class="m-list-title" for>Catatan</span>
                      <span class="m-list-desc">{{
                        data_header.catatan ? data_header.catatan : '-'
                      }}</span>
                    </li>
                  </ul>
                </a-col>
              </a-row>
            </div>
          </a-card>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Detail Kewajiban</h4>

              <a-card>
                <a-input-search
                  v-model="search_detail"
                  style="width: 50%"
                  placeholder="Quick Search"
                  allowClear
                />
              </a-card>

              <a-card class="custom-card">
                <a-table
                  rowKey="kewajiban_dtl_id"
                  :columns="columns_detail"
                  :dataSource="filteredDataDetails"
                  :pagination="pagination"
                  size="small"
                  bordered
                  class="custom-table"
                  :scroll="{ x: 400 }"
                >
                  <template slot="no" slot-scope="text, item, index">
                    {{ index + 1 }}
                  </template>
                  <template slot="no_detail" slot-scope="text, item">
                    {{ item.no_rencana_byr }}
                  </template>

                  <template slot="item_name" slot-scope="text, item">
                    <p>
                      {{ item.nama_item }}
                      <span
                        v-if="item.type_tax !== 'non_tax'"
                        class="tax-label"
                      >
                        - ({{ findTax(item.type_tax) }})
                      </span>
                    </p>
                  </template>

                  <template slot="payment_date" slot-scope="text, item">
                    {{ moment(item.tanggal_byr).format("YYYY-MM-DD") }}
                  </template>

                  <template slot="payment_value" slot-scope="text, item">
                    {{
                      customFormatCurrency(
                        data_header.currency,
                        item.nilai_bayar
                      )
                    }}
                  </template>
                </a-table>
                <div class="table-note">
                  <i>*PPH tidak diperhitungkan</i>
                </div>
              </a-card>

              <div class="table-footer">
                <a-divider />
                <div class="footer-row footer-grand">
                  <span class="footer-label">Grand Total</span>
                  <span class="footer-separator">:</span>
                  <span class="footer-value">
                    {{
                      customFormatCurrency(
                        data_header.currency,
                        total_payment + total_tax
                      )
                    }}
                  </span>
                </div>
              </div>
            </a-collapse-panel>
          </a-collapse>

          <div v-if="false">
            <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <h4 slot="header" class="margin-remove">Tax Deposit Entry</h4>
                <a-card>
                  <a-input-search
                    style="width: 50%"
                    placeholder="Quick Search"
                    allowClear
                  />
                  <a-button
                    v-if="actor == 'Tax Officer'"
                    icon="plus"
                    style="float: right;"
                    type="primary"
                    @click="showModalTax"
                    >Create</a-button
                  >
                </a-card>

                <a-table
                  :columns="columns_tax"
                  :dataSource="data_taxes"
                  :pagination="pagination"
                  size="small"
                  bordered
                  :scroll="{ x: 400 }"
                >
                  <template slot="no_detail" slot-scope="text, item">
                    {{ item.no_rencana_byr }}
                  </template>

                  <template slot="payment_date" slot-scope="text, item">
                    {{ moment(item.tanggal_byr).format("YYYY-MM-DD") }}
                  </template>

                  <template slot="payment_value" slot-scope="text, item">
                    {{ customFormatCurrency("IDR", item.nilai_bayar) }}
                  </template>
                </a-table>
              </a-collapse-panel>
            </a-collapse>
          </div>

          <!-- manifest approval section -->
          <a-card
            class="margin-top"
            title="Manifest Actions"
            v-if="actor !== 'Creator' && data_actions.length > 0"
          >
            <template>
              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['note']"
                  />
                </a-form-item>
                <a-form-item label="Aksi">
                  <a-select
                    showSearch
                    v-decorator="[
                      'status',
                      {
                        rules: [{ required: true }],
                      },
                    ]"
                  >
                    <a-select-option v-for="item in data_actions" :key="item">{{
                      item
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button
                  @click="approval"
                  block
                  type="primary"
                  html-type="submit"
                  :loading="loading.approval"
                  >Save</a-button
                >
              </template>
            </template>
          </a-card>
        </a-col>

        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-card
            :loading="loading.page"
            :class="getScreen ? 'margin-top' : ''"
          >
            <div slot="title">Required Document</div>

            <a-alert
              v-if="files.length === 0"
              type="error"
              message="No document was uploaded!"
              banner
            />

            <a-list v-else itemLayout="horizontal" :dataSource="files">
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div slot="title" class="m-display-flex space-between">
                    <h3 class="margin-remove">
                      <a-icon type="file-text" class="margin-right-small" />
                      {{ item.file_doc }}
                    </h3>

                    <a-button
                      @click="fileHandler(item.kewajiban_doc_id, item.file_doc)"
                      size="small"
                      type="default"
                      icon="eye"
                      :loading="loading.doc"
                    >
                      View
                    </a-button>
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-card>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="lastStatus(data_header.last_status)" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    History
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>

              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data_header.tlc_create }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{ moment(data_header.create_dt).format("DD-MM-YYYY") }}
                    </h4>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data_statuses"
                  :key="workflow.step_no"
                  :color="
                    workflow.status === 'On Process' ||
                    workflow.status === 'Delivered'
                      ? 'red'
                      : workflow.status === 'Waiting'
                      ? 'grey'
                      : 'green'
                  "
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }}
                    {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                  </div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >
                      {{ workflow.tanggal_aksi }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list itemLayout="horizontal" :dataSource="related_list">
                <Empty v-if="related_list.lenght <= 0" />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a
                        @click="navigateTo('manifest_ap', item.kewajiban_ap_id)"
                        >{{ item.header }} | {{ item.tlc_create }}</a
                      >
                      <Status
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.last_status"
                      />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_kewajiban_ap"
                    >
                      <span>{{ item.no_kewajiban_ap }}</span>
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.description
                              ? item.description
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.description
                              ? item.description
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div slot="title" v-if="item.sum_dtl">
                      <span class="m-timeline-title">{{
                        formatCurrency(item.currency, item.sum_dtl)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <a-modal
      :visible="modal_tax"
      @cancel="modalOnClose"
      :footer="null"
      :maskClosable="false"
      width="50%"
    >
      <span slot="title">Add Tax Deposit</span>
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  props: ["id"],
  mixins: [CurrencyFormat],
  data() {
    const columns_detail = [
      {
        title: "No.",
        key: "no",
        width: 60,
        align: "center",
        scopedSlots: { customRender: "no" },
      },
      {
        title: "No. Detail",
        key: "no_detail",
        // width: 180,
        align: "center",
        scopedSlots: { customRender: "no_detail" },
      },
      {
        title: "Nama Item",
        key: "item_name",
        // width: 180,
        dataIndex: "nama_item",
        scopedSlots: { customRender: "item_name" },
      },
      {
        title: "Tanggal Bayar",
        key: "payment_date",
        // width: 180,
        align: "center",
        scopedSlots: { customRender: "payment_date" },
      },
      {
        title: "Nilai Bayar",
        key: "payment_value",
        // width: 180,
        align: "right",
        scopedSlots: { customRender: "payment_value" },
      },
    ];

    const columns_tax = [
      {
        title: "No.",
        key: "no",
        // width: 180,
        align: "center",
        scopedSlots: { customRender: "no" },
      },
      {
        title: "Tax Date",
        key: "tax_date",
        // width: 180,
        align: "center",
        scopedSlots: { customRender: "tax_date" },
      },
      {
        title: "Type Tax",
        key: "type_tax",
        // width: 180,
        align: "center",
        scopedSlots: { customRender: "type_tax" },
      },
      {
        title: "Tax Deposit",
        key: "tax_deposit",
        // width: 180,
        align: "center",
        scopedSlots: { customRender: "tax_deposit" },
      },
      {
        title: "Tax Object",
        key: "tax_object",
        // width: 180,
        align: "center",
        scopedSlots: { customRender: "tax_object" },
      },
      {
        title: "Value DPP",
        key: "value_dpp",
        // width: 180,
        align: "center",
        scopedSlots: { customRender: "value_dpp" },
      },
      {
        title: "Value Tax",
        key: "value_tax",
        // width: 180,
        align: "center",
        scopedSlots: { customRender: "value_tax" },
      },
    ];

    return {
      moment,
      loading: {
        page: false,
        doc: false,
        approval: false,
      },
      data_header: {},
      data_details: [],
      data_statuses: [],
      data_actions: [],
      data_taxes: [],
      pagination: {},
      columns_detail,
      columns_tax,
      actor: "",
      modal_tax: false,
      search_detail: "",
      related_list: [],
    };
  },

  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStandartFormatDate",
      "getDateTimeStandartFormat",
      "getType_tax",
    ]),

    files() {
      try {
        let hardcodeFiles = [];
        if(this.data_header.jenis_kewajiban == 'Rekapitulasi'){
          hardcodeFiles = [{
            file_doc: 'Rekapitulasi' + (this.data_header.type_trans == 'rekap_lkpd' ? ' (LKPD)' : ' (Klaim Kesehatan)'),
            kewajiban_doc_id: this.data_header.trans_id
          }]
        }
        return [...hardcodeFiles, ...JSON.parse(this.data_header.files || "[]")];
      } catch (error) {
        return [];
      }
    },

    filteredDataDetails() {
      if (!this.search_detail) return this.data_details;

      const keyword = this.search_detail.toLowerCase().trim();

      return this.data_details.filter((item) => {
        return (
          String(item.no_rencana_byr || "")
            .toLowerCase()
            .includes(keyword) ||
          String(item.nama_item || "")
            .toLowerCase()
            .includes(keyword) ||
          String(item.type_tax || "")
            .toLowerCase()
            .includes(keyword) ||
          String(item.tanggal_byr || "")
            .toLowerCase()
            .includes(keyword)
        );
      });
    },

    total_payment() {
      return this.data_details.reduce((total, item) => {
        if (item.type_tax == "non_tax") {
          return total + Number(item.nilai_bayar || 0);
        }
        return total;
      }, 0);
    },

    total_tax() {
      return this.data_details.reduce((total, item) => {
        const type = String(item.type_tax || "").toLowerCase();

        if (type.includes("ppn")) {
          return total + Number(item.nilai_bayar || 0);
        }
        return total;
      }, 0);
    },

    total_pph() {
      return this.data_details.reduce((total, item) => {
        const type = String(item.type_tax || "").toLowerCase();

        if (!type.includes("ppn") && type !== "non_tax") {
          return total + Number(item.nilai_bayar || 0);
        }

        return total;
      }, 0);
    },
  },

  beforeCreate() {
    this.form = this.$form.createForm(this);
  },

  created() {
    this.fetchData();
    this.$store.dispatch("Fetch_TYPE_TAX");
  },

  mounted() {},

  methods: {
    async fetchData() {
      try {
        this.loading.page = true;
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + `kewajiban/manifest`,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          params: {
            manifest_id: this.id,
          },
        });

        if (response.data) {
          this.data_header = response.data.data;
          this.data_details = response.data.detail;
          this.data_statuses = response.data.statuses;
          this.data_taxes = response.data.taxes;
          this.data_actions = response.data.action;
          this.actor = response.data.actor_as;
          this.related_list = response.data.related;
        }
        this.loading.page = false;
      } catch (error) {
        this.loading.page = false;
        console.log(error);
      }
    },

    async fileHandler(id, fileName) {
      try {
        this.loading.doc = true;
        this.loading.list = true;
        let url_ = 'kewajiban/file/';
        if(fileName=='Rekapitulasi (LKPD)'){
          url_ = 'rekap_lkpd/cetak?id_rekap_lkpd='
        }else if(fileName=='Rekapitulasi (Klaim Kesehatan)'){
          url_ = 'rekap_kesehatan/cetak?id_rekap_klaim='
        }

        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + `${url_}${id}`,
          responseType: "blob",
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        });

        this.loading.doc = false;

        const blob = response.data;
        const mimeType = blob.type;
        const url = window.URL.createObjectURL(blob);

        // PDF atau gambar -> buka tab baru
        if (mimeType === "application/pdf" || mimeType.startsWith("image/")) {
          window.open(url, "_blank");
          return;
        }

        const link = document.createElement("a");
        link.href = url;

        const disposition = response.headers["content-disposition"];
        let filename = fileName;

        if (disposition) {
          const match = disposition.match(/filename="?(.+?)"?$/);
          if (match) {
            filename = match[1];
          }
        }

        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.log(error);
        this.loading.doc = false;
      }
    },

    approval() {
      this.loading.approval = true;
      this.form.validateFields(async (err, values) => {
        if (err) {
          this.loading.approval = false;
          return;
        }

        try {
          const payload = {
            note: values.note ? values.note : "",
            manifest_id: this.id,
            status: values.status,
          };

          const response = await axios({
            method: "POST",
            url: this.$serviceUrl + `kewajiban/approval`,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
            data: payload,
          });
          this.displayMessageValue("success-other", response.data.message);
          this.fetchData();
          this.loading.approval = false;
        } catch (error) {
          this.loading.approval = false;
          console.log(error);
        }
      });
    },

    historyToggle(e) {
      e.stopPropagation();
    },

    showModalTax() {
      this.modal_tax = true;
    },

    modalOnClose() {
      this.modal_tax = false;
    },

    navigateTo(name, id = "") {
      if (name == "manifest_ap") {
        this.$router.push({
          name: 'ap_kewajiban_manifest',
          params: {
            id: id
          }
        })
      } else if (name == "kewajiban_edit") {
        this.$store.dispatch("setSelectedReminder", null);
        this.$router.push({
          name: name,
          params: {
            id: id,
          },
        });
      }
    },

    findTax(item) {
      const find = this.getType_tax.find((e) => e.value == item);
      if (find) {
        return find.text;
      }
      return "";
    },

    lastStatus(val) {
      if (this.data_header.cancel_sts == "1") return "Canceled";
      else if (val == "Delivered") return "On Process";
      else return val;
    },

    gotoManifest(id){
      let res = "notificationProspectmanifest"
      if(this.$route.path.includes('/marketing/')){
        res = "manifestProspectNotification"
      } else if(this.$route.path.includes('/direktur/')){
        res = "manifestProspectNotificationDir"
      } else if(this.$route.path.includes('/financialControl/')){
        res = "manifestProspectNotificationFC"
      } else if(this.$route.path.includes('/akuntansiKeuangan/')){
        res = "manifestProspectNotificationACC"
      } else if(this.$route.path.includes('/programme/')){
        res = "manifestProspectNotificationProg"
      }
      const route = this.$router.resolve({
        name: res,
        params: { id: id },
      });
      window.open(route.href, "_blank");
    }
  },
};
</script>

<style>
.tax-label {
  font-weight: bold;
  font-style: italic;
}

.footer-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.footer-row:last-child {
  margin-bottom: 0;
}

.footer-label {
  width: 120px; /* Biar ":" sejajar */
  font-weight: 600;
}

.footer-separator {
  width: 20px;
  text-align: center;
}

.footer-value {
  flex: 1;
  text-align: right; /* Mentok kanan */
  font-weight: 600;
}

.table-note {
  margin-top: -50px;
  padding: 10px;
  font-size: 0.75rem;
}
</style>
